import { render } from "./ContractOverview.vue?vue&type=template&id=1821bd0f"
import script from "./ContractOverview.vue?vue&type=script&lang=js"
export * from "./ContractOverview.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__